import { Link } from "react-router-dom";
import { BookOpen, GraduationCap, Presentation, Signpost, Users, Building2 } from "lucide-react";
import { useSeo } from "@/lib/site";

const SERVICES = [
  { Icon: BookOpen, t: "Confidential family-support resources" },
  { Icon: GraduationCap, t: "Employee education" },
  { Icon: Presentation, t: "Awareness workshops" },
  { Icon: Signpost, t: "Specialist signposting" },
  { Icon: Users, t: "Educational sessions for teams" },
  { Icon: Building2, t: "Organisational wellbeing partnerships" },
];

export default function Organisations() {
  useSeo("For Organisations", "Supporting employees whose lives are affected by someone else's addiction. Register your interest.");
  return (
    <div data-testid="organisations-page">
      <section className="container-site pt-14 md:pt-20 max-w-5xl">
        <p className="eyebrow mb-4">For Organisations</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">Supporting employees whose lives are affected by addiction.</h1>
        <div className="mt-8 grid gap-6 md:grid-cols-2 text-lg text-ink-soft">
          <p>Many people go to work each day while supporting a partner, parent, child or friend through addiction. The worry, disrupted sleep, financial strain and emotional exhaustion that can come with this rarely stay at home.</p>
          <p>It can affect concentration, wellbeing, relationships and attendance, often silently, because people feel unable to talk about it. Most workplace support focuses on the person experiencing addiction, not the people around them.</p>
        </div>
      </section>
      <section className="container-site mt-16">
        <blockquote className="rounded-[2.5rem] bg-[#1E2326] text-cream p-8 sm:p-12 lg:p-16 font-serif text-2xl sm:text-3xl lg:text-4xl leading-snug" data-testid="employer-value-proposition">
          “Addiction &amp; Us helps organisations recognise and support an often-overlooked wellbeing challenge: the impact of addiction on the people around it.”
        </blockquote>
      </section>
      <section className="container-site mt-16" aria-labelledby="org-services-heading">
        <h2 id="org-services-heading" className="text-3xl sm:text-4xl">Areas we'd like to explore with organisations</h2>
        <p className="mt-3 text-ink-soft max-w-2xl">These are areas for future partnership discussions. None are currently offered or available to buy.</p>
        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map(({ Icon, t }) => <li key={t} className="rounded-3xl bg-teal-light p-6 flex items-center gap-4"><Icon className="h-6 w-6 text-teal shrink-0" aria-hidden="true" /><span className="font-semibold">{t}</span></li>)}
        </ul>
      </section>
      <section className="container-site mt-20 max-w-4xl" aria-labelledby="eoi-heading" data-testid="org-contact-section">
        <h2 id="eoi-heading" className="text-3xl sm:text-4xl">Register your interest</h2>
        <p className="mt-4 text-ink-soft">If your organisation would like to explore this with us, we'd be glad to hear from you. This is an expression of interest, not an order or a commitment.</p>
        <Link to="/contact#partnerships" className="btn-primary mt-6" data-testid="org-contact-btn">Partnership contact details</Link>
      </section>
    </div>
  );
}
